module.exports = __webpack_public_path__ + "static/img/donga-stillen.04b4940.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/donga-stillen.jpg
// module id = /LvR
// module chunks = 0